function format (d) {
  return {
    ...d,
    select: false,
  }
}

const spells = [
  {
    spellClass: 'air',
    list: [
      { name: 'haste', level: 1 },
      { name: 'lightningBolt', level: 2 },
      { name: 'disruptingRay', level: 2 },
      { name: 'precision', level: 2 },
      { name: 'protectionFromAir', level: 2 },
      { name: 'airShield', level: 3 },
      { name: 'destroyUndead', level: 3 },
      { name: 'counterstrike', level: 4 },
      { name: 'chainLightning', level: 4 },
    ].map(format)
  },
  {
    spellClass: 'earth',
    list: [
      { name: 'slow', level: 1 },
      { name: 'stoneSkin', level: 1 },
      { name: 'shield', level: 1 },
      { name: 'deathRipple', level: 2 },
      { name: 'animateDead', level: 3 },
      { name: 'forceField', level: 3 },
      { name: 'protectionFromEarth', level: 3 },
      { name: 'antiMagic', level: 3 },
      { name: 'meteorShower', level: 4 },
      { name: 'implosion', level: 5 },
    ].map(format)
  },
  {
    spellClass: 'fire',
    list: [
      { name: 'bloodlust', level: 1 },
      { name: 'protectionFromFire', level: 1 },
      { name: 'curse', level: 1 },
      { name: 'blind', level: 2 },
      { name: 'fireball', level: 3 },
      { name: 'armageddon', level: 4 },
      { name: 'fireShield', level: 4 },
      { name: 'frenzy', level: 4 },
      { name: 'sacrifice', level: 5 },
    ].map(format)
  },
  {
    spellClass: 'water',
    list: [
      { name: 'bless', level: 1 },
      { name: 'cure', level: 1 },
      { name: 'dispel', level: 1 },
      { name: 'protectionFromWater', level: 1 },
      { name: 'weakness', level: 2 },
      { name: 'frostRing', level: 3 },
      { name: 'teleport', level: 3 },
      { name: 'prayer', level: 4 },
    ].map(format)
  },
]

export default spells
